module.exports = __webpack_public_path__ + "static/TransparentBook-20bcb438e3f09d49295ff2f2a6efd378.png";